// AboutSection.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

function AboutSection() {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.3 });
  const isMobile = window.innerWidth <= 768;

  return (
    <section
      ref={ref}
      style={{
        height: '100vh',
        scrollSnapAlign: 'start',
        padding: isMobile ? '40px 5vw' : '60px 20px',
        backgroundColor: '#ffffff',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        style={{ fontSize: isMobile ? '6vw' : '2rem', marginBottom: '20px' }}
      >
        회사 소개
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ delay: 0.3, duration: 0.6 }}
        style={{
          maxWidth: '800px',
          fontSize: isMobile ? '4vw' : '1.1rem',
          lineHeight: '1.7',
          color: '#444',
          whiteSpace: 'pre-line'
        }}
      >
        {`㈜인더텍은 디지털 헬스케어 및 인지 치료 전문 기업으로\nADHD, MCI, 치매 등 다양한 인지질환 솔루션을 개발해왔습니다.\n\nEYAS-Focus는 비약물 디지털 치료제로,\n모바일 기반 시선 추적 기술을 통해 ADHD 아동의 집중력을\n정량적으로 분석하고 훈련할 수 있도록 돕는 제품입니다.`}
      </motion.p>
    </section>
  );
}

export default AboutSection;